import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useInventoryStore } from '../../store/inventoryStore'
import { recordInTransaction } from '../../utils/recordInTransaction'
import type { InventoryInTransactionCreateData } from '../../schema/inventorySchema'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useRecordInTransactionMutation = (onSuccess?: () => void) => {
  const addTransaction = useInventoryStore((state) => state.addTransaction)
  const inventoryStock = useInventoryStore((state) => state.inventoryStock)
  const updateInventoryStock = useInventoryStore(
    (state) => state.updateInventoryStock,
  )
  const addInventoryStock = useInventoryStore(
    (state) => state.addInventoryStock,
  )

  return useMutation({
    mutationFn: ({
      transaction,
      invoiceFile,
    }: {
      transaction: InventoryInTransactionCreateData
      invoiceFile?: File
    }) => recordInTransaction(transaction, invoiceFile),
    onSuccess: ({ message, transaction, stock }) => {
      console.log('Recorded in transaction:', transaction, stock)
      addTransaction(transaction)

      const existingStock = inventoryStock.find((s) => s._id === stock._id)
      !existingStock ? addInventoryStock(stock) : updateInventoryStock(stock)

      toast.success(message || 'In transaction recorded successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while recording in transaction.',
      )
    },
  })
}
